var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-app',{staticStyle:{"background":"linear-gradient(130deg, #FF0099, #493240)"},attrs:{"id":"inspire"}},[_c('AppBar'),_c('LoginBox',{attrs:{"is-register":false}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }